module.exports = __webpack_public_path__ + "media/images/dublicate_wt-953629432a57f05bdc46e7ffc3f2a08c.png";